import { render, staticRenderFns } from "./salutation.vue?vue&type=template&id=e032a67a"
import script from "./salutation.vue?vue&type=script&lang=js"
export * from "./salutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports